import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=31ff8a6c&scoped=true"
import script from "./paymentMethod.vue?vue&type=script&lang=js"
export * from "./paymentMethod.vue?vue&type=script&lang=js"
import style0 from "./paymentMethod.vue?vue&type=style&index=0&id=31ff8a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff8a6c",
  null
  
)

export default component.exports